module.exports = __webpack_public_path__ + "static/img/index.2915e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/index.png
// module id = zqB6
// module chunks = 44